'use client';

import HeroSection from './HeroSection';
import PropertyShowcase from './PropertyShowcase';
import LocalExperiencesPreview from './LocalExperiencesPreview';
import TestimonialCarousel from './TestimonialCarousel';
import TrustSignals from './TrustSignals';
import LiveActivity from './LiveActivity';
import CallToAction from './CallToAction';
import Footer from './Footer';

interface SeasonalData {
  season: string;
  title: string;
  subtitle: string;
  image: string;
  alt: string;
  highlights: string[];
}

interface PropertyData {
  name: string;
  category: string;
  images: Array<{ url: string; alt: string }>;
  bedrooms: number;
  bathrooms: number;
  maxGuests: number;
  size: string;
  features: string[];
  description: string;
  pricePerNight: number;
  amenities: string[];
  virtualTourUrl: string;
}

interface Experience {
  id: number;
  title: string;
  category: string;
  description: string;
  image: string;
  alt: string;
  duration: string;
  difficulty: string;
  icon: string;
}

interface Testimonial {
  id: number;
  name: string;
  location: string;
  image: string;
  alt: string;
  rating: number;
  review: string;
  stayDate: string;
  propertyName: string;
}

interface TrustSignal {
  id: number;
  icon: string;
  title: string;
  description: string;
  stat: string;
}

interface Activity {
  id: number;
  type: 'booking' | 'checkin' | 'event';
  message: string;
  time: string;
  icon: string;
}

interface HomepageInteractiveProps {
  seasonalData: SeasonalData;
  property: PropertyData;
  experiences: Experience[];
  testimonials: Testimonial[];
  trustSignals: TrustSignal[];
  activities: Activity[];
}

export default function HomepageInteractive({
  seasonalData,
  property,
  experiences,
  testimonials,
  trustSignals,
  activities,
}: HomepageInteractiveProps) {
  return (
    <>
      <HeroSection data-component-id="src/app/homepage/components/HomepageInteractive.tsx:95:6" data-component-path="src/app/homepage/components/HomepageInteractive.tsx" data-component-line="95" data-component-end-line="95" data-component-file="HomepageInteractive.tsx" data-component-name="HeroSection" data-component-content="%7B%22elementName%22%3A%22HeroSection%22%7D" seasonalData={seasonalData} />
      <LiveActivity data-component-id="src/app/homepage/components/HomepageInteractive.tsx:96:6" data-component-path="src/app/homepage/components/HomepageInteractive.tsx" data-component-line="96" data-component-end-line="96" data-component-file="HomepageInteractive.tsx" data-component-name="LiveActivity" data-component-content="%7B%22elementName%22%3A%22LiveActivity%22%7D" activities={activities} />
      <PropertyShowcase data-component-id="src/app/homepage/components/HomepageInteractive.tsx:97:6" data-component-path="src/app/homepage/components/HomepageInteractive.tsx" data-component-line="97" data-component-end-line="97" data-component-file="HomepageInteractive.tsx" data-component-name="PropertyShowcase" data-component-content="%7B%22elementName%22%3A%22PropertyShowcase%22%2C%22%5Bspread%5D%22%3A%22true%22%7D" {...property} />
      <LocalExperiencesPreview data-component-id="src/app/homepage/components/HomepageInteractive.tsx:98:6" data-component-path="src/app/homepage/components/HomepageInteractive.tsx" data-component-line="98" data-component-end-line="98" data-component-file="HomepageInteractive.tsx" data-component-name="LocalExperiencesPreview" data-component-content="%7B%22elementName%22%3A%22LocalExperiencesPreview%22%7D" experiences={experiences} />
      <TestimonialCarousel data-component-id="src/app/homepage/components/HomepageInteractive.tsx:99:6" data-component-path="src/app/homepage/components/HomepageInteractive.tsx" data-component-line="99" data-component-end-line="99" data-component-file="HomepageInteractive.tsx" data-component-name="TestimonialCarousel" data-component-content="%7B%22elementName%22%3A%22TestimonialCarousel%22%7D" testimonials={testimonials} />
      <TrustSignals data-component-id="src/app/homepage/components/HomepageInteractive.tsx:100:6" data-component-path="src/app/homepage/components/HomepageInteractive.tsx" data-component-line="100" data-component-end-line="100" data-component-file="HomepageInteractive.tsx" data-component-name="TrustSignals" data-component-content="%7B%22elementName%22%3A%22TrustSignals%22%7D" signals={trustSignals} />
      <CallToAction data-component-id="src/app/homepage/components/HomepageInteractive.tsx:101:6" data-component-path="src/app/homepage/components/HomepageInteractive.tsx" data-component-line="101" data-component-end-line="101" data-component-file="HomepageInteractive.tsx" data-component-name="CallToAction" data-component-content="%7B%22elementName%22%3A%22CallToAction%22%7D" />
      <Footer data-component-id="src/app/homepage/components/HomepageInteractive.tsx:102:6" data-component-path="src/app/homepage/components/HomepageInteractive.tsx" data-component-line="102" data-component-end-line="102" data-component-file="HomepageInteractive.tsx" data-component-name="Footer" data-component-content="%7B%22elementName%22%3A%22Footer%22%7D" />
    </>
  );
}